module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.12@core-js/library/modules/_add-to-unscopables.js
// module id = SKL3
// module chunks = 11